module.exports = __webpack_public_path__ + "img/icon_content_index_1.0.1.0_202503250930.png";